import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#0E1425',
      paper: '#0E1425',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#B0B0B0',
      disabled: '#666666',
    },
    divider: '#333333',
    primary: {
      main: '#d66ee9',
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          color: 'inherit',
          fontFamily: 'inherit',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: '#FFFFFF',
          backgroundColor: '#0E1425',
          fontFamily: 'inherit',
        },
        input: {
          '&::placeholder': {
            color: '#666666',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          '& fieldset': {
            borderColor: '#333333',
          },
          '&:hover fieldset': {
            borderColor: '#666666',
          },
          '&.Mui-focused fieldset': {
            borderColor: '#FFFFFF',
          },
          margin: '5px',
          fontFamily: 'inherit',
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#666666',
          '&.Mui-checked': {
            color: '#FFFFFF',
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#666666',
          '&.Mui-checked': {
            color: '#FFFFFF',
          },
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        thumb: {
          color: '#FFFFFF',
        },
        track: {
          backgroundColor: '#666666',
          '&.Mui-checked': {
            backgroundColor: '#FFFFFF',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: '1px solid #333333',
          color: '#FFFFFF',
          fontFamily: 'inherit',
        },
        head: {
          backgroundColor: '#0E1425',
          color: '#FFFFFF',
        },
        body: {
          backgroundColor: '#0E1425',
          color: '#B0B0B0',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          margin: '5px',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
            margin: '5px',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          margin: '5px',
          fontFamily: 'inherit',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          margin: '5px',
        },
      },
    },
  },
});

export default theme;
